export const view012ImageOptions = {
  angle: 'view012',
  staticOptions: {
    HullColour: 1,
    Deck: 1,
    BiminiColor: 1,
    TTop: 1,
    GrabRails: 1,
    BowOption: 1,
    UpholsteryCockpit: 1,
    Engine: 1,
    AnchorStern: 1,
    AnchorBow: 1,
    Galley: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'UpholsteryCockpit',
      dependency: 'TTop'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view012.js